module.exports = __webpack_public_path__ + "img/brightcove.f1d2a760.png";